import {map, take} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../shared/api.service';

@Injectable()
export class AnalyticsService {

  constructor(private http: HttpClient,
              private apiService: ApiService) {}

  public getStatistics(filter: any) : Observable<any> {
    return this.http.post(this.apiService.getStatistics(), filter).pipe(take(1),map(value => {
      return value;
    }),);
  }
}
